import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api.js';
import './deployments.css';

interface DeploymentRow {
  id: string;
  stackId: string;
  environmentId: string;
  kind: string;
  gitRef: string;
  gitSha: string;
  status: string;
  ranMigrations: boolean;
  createdAt: string;
  finishedAt: string | null;
}

export function DeploymentsPage() {
  const navigate = useNavigate();
  const { data: deployments } = useQuery<DeploymentRow[]>({
    queryKey: ['deployments'],
    queryFn: () => apiFetch('/deployments'),
    refetchInterval: 10_000,
  });

  return (
    <div>
      <header className="page-header">
        <div>
          <p className="page-eyebrow">Pipeline History</p>
          <h1>Deployments</h1>
        </div>
      </header>
      <table className="data-table">
        <thead>
          <tr>
            <th>When</th>
            <th>Ref</th>
            <th>SHA</th>
            <th>Kind</th>
            <th>Migrations</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {(deployments ?? []).map((d) => (
            <tr key={d.id} className="clickable" onClick={() => navigate(`/deployments/${d.id}`)}>
              <td>{new Date(d.createdAt).toLocaleString()}</td>
              <td className="mono">{d.gitRef}</td>
              <td className="mono">{d.gitSha.slice(0, 8)}</td>
              <td>{d.kind}</td>
              <td>{d.ranMigrations ? 'yes' : '—'}</td>
              <td>
                <span className={`deploy-status deploy-status-${d.status}`}>{d.status}</span>
              </td>
            </tr>
          ))}
          {deployments && deployments.length === 0 ? (
            <tr>
              <td colSpan={6} className="dim">
                No deployments yet.
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
